export default __webpack_public_path__ + "static/media/hbm.3f6b2f4d.png";